import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {Modal} from '@/components/common/modal/Modal'
import {TipItem} from '@/components/common/tips/TipItem'
import {FORM_MODAL_WIDTH} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {TipItemCategoryType} from './types'

type TipsModalProps = {
  isVisible: boolean
  title: string
  description: string
  categories: TipItemCategoryType[]
  closeModal: () => void
}

export const TipsModal: FC<TipsModalProps> = ({
  isVisible,
  title,
  description,
  categories,
  closeModal,
}) => (
  <>
    <Modal isVisible={isVisible} closeModal={closeModal} isMobileFullScreen>
      <div className="content">
        <Text variant={TextVariant.h3} element="h2">
          {title}
        </Text>
        <div className="description">
          <Text>{description}</Text>
        </div>
        <div className="tips">
          {categories.map((category) => (
            <TipItem key={category.title} category={category} />
          ))}
        </div>
      </div>
    </Modal>

    <style jsx>{`
      .content {
        min-width: ${FORM_MODAL_WIDTH};
        max-width: ${FORM_MODAL_WIDTH};
        margin: ${theme.spacing[2]};
      }
      .description {
        margin-top: ${theme.spacing[2]};
      }
      .tips {
        margin-top: ${theme.spacing[6]};
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .content {
          min-width: inherit;
          max-width: inherit;
          margin: ${theme.spacing[2]} 0;
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .tips {
          margin-top: ${theme.spacing[5]};
        }
      }
    `}</style>
  </>
)
